import React from "react";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white text-sky-700 text-xl font-semibold">
    
    </div>
  );
};

export default Loader;
